module.exports = __webpack_public_path__ + "img/Recilaser.204ba303.jpg";